import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectOption from 'lib/SelectOption';
import { Label } from 'lib/Label';
import { mediaTypeDataOptions } from 'consts/mediaTypeDataOptions';
import { hideSecondaryPanel } from 'store/productManagement/reducer';
import { Store } from 'components/common/types/Store.types';
import { DirectSalesMediaTypeLabel } from 'components/common/types/DirectSalesCampaign.types';
import { isValueRequired } from 'components/pages/PCM/Products/utils/isValueRequired';
import { CodeNameModel } from 'components/common/types';
import SectionDivider from 'components/pages/Planner/SectionDivider';
import SelectionPermissionDropdown from '../SelectionPermissionDropdown/SelectionPermissionDropdown';
import { requiredFixedValueFieldPermissionOptions } from '../../consts';
import { isPanelConfirmDisabled } from '../../utils/isPanelConfirmDisabled';
import { ProductMediaTypePanelProps } from './ProductMediaType.types';
import { secondaryPanelLayoutStyles } from '../../styles';
import { ProductSecondaryPanel } from '../ProductSecondaryPanel/ProductSecondaryPanel';

const ProductMediaTypePanel: React.FC<ProductMediaTypePanelProps> = ({ onConfirm, isReadOnly = false }) => {
  const dispatch = useDispatch();
  const defaultMediaType = useSelector((state: Store) => state.productManagement.newProduct.mediaType);
  const defaultSelectedPermission =
    requiredFixedValueFieldPermissionOptions.find(({ code }) => code === defaultMediaType?.selectionPermission) ??
    requiredFixedValueFieldPermissionOptions[0];

  const [selectedPermission, setSelectedPermission] = useState<CodeNameModel>(defaultSelectedPermission);
  const [mediaType, setMediaType] = useState(defaultMediaType?.value);

  const hasMediaTypeChanges =
    selectedPermission.code !== defaultMediaType?.selectionPermission || mediaType !== defaultMediaType?.value;

  return (
    <ProductSecondaryPanel
      size="md"
      title="Media type"
      onSubmit={() => onConfirm({ value: mediaType, selectedPermission })}
      onCancel={() => dispatch(hideSecondaryPanel())}
      isDisabled={
        isPanelConfirmDisabled({ field: defaultMediaType, selectedPermission, newFieldValue: mediaType }) || isReadOnly
      }
      customStyles={secondaryPanelLayoutStyles}
      isChange={hasMediaTypeChanges}
    >
      <SelectionPermissionDropdown
        selectedPermission={selectedPermission}
        setSelectedPermission={setSelectedPermission}
        permissionOptions={requiredFixedValueFieldPermissionOptions}
      />
      {isValueRequired(selectedPermission.code) ? (
        <>
          <div className="my-4">
            <SectionDivider />
          </div>

          <Label label="Select media type" />

          <div className="flex flex-col space-y-1">
            {mediaTypeDataOptions.map((option) => (
              <SelectOption
                key={option.code}
                value={option}
                isSelected={mediaType === option.code}
                onClick={() => setMediaType(option.code)}
                hasRadio
              >
                {DirectSalesMediaTypeLabel[option.code]}
              </SelectOption>
            ))}
          </div>
        </>
      ) : null}
    </ProductSecondaryPanel>
  );
};

export default ProductMediaTypePanel;
